import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApplicantDataSerializer } from '@app/model/serializer/applicant-data-serializer';
import { Applicant } from '@app/model/applicant';


@Injectable({ providedIn: 'root' })
export class ApplicantDataService extends ApiService<Applicant> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'applicant/applicant-data',
      new ApplicantDataSerializer());
  }
}
